import { createContext } from 'react';

const StepNavigationContext = createContext({}) as any;
export const StepNavigationContextProvider = StepNavigationContext.Provider;

export default StepNavigationContext;
